"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessDeleteUserBodyToJSON = exports.BusinessDeleteUserBodyFromJSONTyped = exports.BusinessDeleteUserBodyFromJSON = void 0;
function BusinessDeleteUserBodyFromJSON(json) {
    return BusinessDeleteUserBodyFromJSONTyped(json, false);
}
exports.BusinessDeleteUserBodyFromJSON = BusinessDeleteUserBodyFromJSON;
function BusinessDeleteUserBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': json['userId'],
    };
}
exports.BusinessDeleteUserBodyFromJSONTyped = BusinessDeleteUserBodyFromJSONTyped;
function BusinessDeleteUserBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
    };
}
exports.BusinessDeleteUserBodyToJSON = BusinessDeleteUserBodyToJSON;
